import React from 'react'
import { Box, Typography } from '@mui/material'

export default function CategoryCard({ title, image, overlayColor, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'relative',
        height: 100,
        borderRadius: 3,
        overflow: 'hidden',
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'Top',
        cursor: 'pointer'
      }}
    >
      {/* colored overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'hsla(0, 0.00%, 3.90%, 0.50)',
          opacity: 0.75
        }}
      />
      {/* category title */}
      <Typography
        variant="h6"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'common.white',
          fontWeight: 'bold'
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}
